import { ArrayInput, Button, SimpleFormIterator, TextInput, useNotify } from "react-admin";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import { settings } from "app";
import dataProvider from "server/dataProvider";
import FormModal from "server/components/Modals/FormModal";
import { publicationRequests } from "api/publicationApi";

// The iterator works on objects, so the plain string array is wrapped as { name } for the form and unwrapped on save.
const EditAuthorNamesDialog = ({ authorNames, onSaved }) => {
  const notify = useNotify();
  const hasNames = authorNames.length > 0;

  const handleSubmit = async data => {
    const publicationAuthorNames = (data.names ?? []).map(item => item?.name?.trim()).filter(Boolean);

    await dataProvider.customRequest(
      publicationRequests.publicationProfileAuthorNames(),
      { publicationAuthorNames },
      "PUT",
    );
    notify("Имената са запазени успешно", { type: "success" });
    onSaved();
  };

  return (
    <FormModal
      titleContent="Имена в публикации"
      onConfirm={handleSubmit}
      defaultValues={{ names: hasNames ? authorNames.map(name => ({ name })) : [{ name: "" }] }}
      saveTitle="Запази"
      dialogSize="md"
      triggerButton={
        <Button
          label={hasNames ? "Редактирай" : "Добави"}
          startIcon={hasNames ? <EditIcon /> : <AddIcon />}
        />
      }
    >
      <ArrayInput
        source="names"
        label="Имената, под които сте вписан в публикациите"
      >
        <SimpleFormIterator
          disableReordering
          sx={settings.style.iteratorWithoutGap}
        >
          <TextInput
            source="name"
            label="Име"
            fullWidth
          />
        </SimpleFormIterator>
      </ArrayInput>
    </FormModal>
  );
};

export default EditAuthorNamesDialog;
